module.exports = __webpack_public_path__ + "static/media/sp_open.ab7153c0.svg";